import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Component displays right arrow icon
 * @param props -SvgIconProps
 * @returns svg of right arrow icon
 * @example <CcfRightArrowIcon/>
 */
export function CcfRightArrowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.7736 9.00497L7.35849 2.23881C7.0566 1.9204 6.5283 1.9204 6.22642 2.23881C5.92453 2.55721 5.92453 3.11443 6.22642 3.43284L12.2642 9.80099L6.22642 16.5672C5.92453 16.8856 5.92453 17.4428 6.22642 17.7612C6.5283 18.0796 7.0566 18.0796 7.35849 17.7612L13.7736 10.597C14 10.3582 14 10.1194 14 9.8806C14 9.48259 13.9245 9.16418 13.7736 9.00497Z"
          fill="#333333"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfRightArrowIcon;
